export const tableData = [{
    title:"疑难杂症解决方案",
    type:"网页模板",
    userID:1,
    userNick:"昵称",
    status:"审核通过"
},{
    title:"疑难杂症解决方案",
    type:"网页模板",
    userID:1,
    userNick:"昵称",
    status:"审核通过"
},{
    title:"疑难杂症解决方案",
    type:"网页模板",
    userID:1,
    userNick:"昵称",
    status:"审核通过"
},{
    title:"疑难杂症解决方案",
    type:"网页模板",
    userID:1,
    userNick:"昵称",
    status:"审核通过"
},{
    title:"疑难杂症解决方案",
    type:"网页模板",
    userID:1,
    userNick:"昵称",
    status:"审核通过"
}];